import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-profile" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "body__profile" }
const _hoisted_4 = { class: "body__profile--icon" }
const _hoisted_5 = { class: "body__profile--info" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "body__items" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "item__value" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = { class: "item__value" }
const _hoisted_12 = { class: "item" }
const _hoisted_13 = { class: "item__value" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "item__value" }
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "item__value" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = { class: "item__value" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = { class: "item__value" }
const _hoisted_22 = { class: "item" }
const _hoisted_23 = { class: "item__value" }
const _hoisted_24 = { class: "action" }
const _hoisted_25 = { class: "new-modal" }
const _hoisted_26 = { class: "description__footer" }

import { User02, Edit02 } from "utruckin-icons";
import { useUserStore } from "@/features/users/user.store";
import CommonButton from "@/components/common/CommonButton.vue";
import { ref } from "vue";
import CommonInput from "@/components/common/CommonInput.vue";
import CommonModal from "@/components/common/CommonModal.vue";
import { useNotification } from "@/utils/notification";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const usersStore = useUserStore();
const { pushNotification } = useNotification();

const password = ref<string>("");
const confirmPassword = ref<string>("");
const passwordModal = ref<boolean>(false);
const modalLoading = ref<boolean>(false);

const openModal = () => {
  password.value = "";
  confirmPassword.value = "";
  passwordModal.value = true;
};

const closeModal = () => {
  password.value = "";
  confirmPassword.value = "";
  passwordModal.value = false;
};

const saveModal = async () => {
  if (!(password.value.length > 5) || password.value !== confirmPassword.value)
    return;

  const result = await usersStore.changePassword(
    modalLoading,
    usersStore.userProfile?.id as string,
    {
      new_password: password.value,
    }
  );

  if (result) {
    pushNotification("Password changed successfully", "success");
    closeModal();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(User02), { size: 20 })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(usersStore).userProfile?.name), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "item__label" }, "Email:", -1)),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(usersStore).userProfile?.email || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "item__label" }, "Phone number:", -1)),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(usersStore).userProfile?.phone_number || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "item__label" }, "Team:", -1)),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(usersStore).userProfile?.team_name || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "item__label" }, "Role:", -1)),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(usersStore).userProfile?.role || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "item__label" }, "Date of birth:", -1)),
          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(usersStore).userProfile?.date_of_birth || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "item__label" }, "Working since:", -1)),
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(usersStore).userProfile?.working_since || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "item__label" }, "Default day off:", -1)),
          _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(usersStore).userProfile?.default_day_off || "-"), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "item__label" }, "Monthly wage:", -1)),
          _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(usersStore).userProfile?.monthly_wage || "-"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createVNode(CommonButton, {
          label: "Change password",
          onClick: openModal
        })
      ])
    ]),
    _createVNode(CommonModal, {
      modelValue: passwordModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((passwordModal).value = $event)),
      title: "Password change"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: closeModal
          }),
          _createVNode(CommonButton, {
            "is-disabled": 
              !(password.value.length > 5) || password.value !== confirmPassword.value
            ,
            type: "primary",
            label: "Save",
            onClicked: saveModal
          }, null, 8, ["is-disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(CommonInput, {
            type: "password",
            modelValue: password.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
            label: "New password"
          }, null, 8, ["modelValue"]),
          _createVNode(CommonInput, {
            type: "password",
            modelValue: confirmPassword.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confirmPassword).value = $event)),
            label: "Confirm password"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})